export const template = {
  pageTitle: "Our Story",
  contents: {
    dynamicContents: [
      {
        id: 1,
        title: "How it all began",
        subContents:
          "<strong>our idea of the perfect closet solution</strong>",
      },
      {
        id: 2,
        title: "",
        subContents:
          "Roger Washburn started out working as an Installer for corporate Classy Closets in Arizona.  After a few years he became a partner with the local franchisees in Salt Lake City, and after a few more years he and his wife Patty bought his partners out to become sole owner of the Utah Classy Closet Franchise (except St. George).  ",
      },
      {
        id: 3,
        title: "",
        subContents:
          "Roger knows and understands the business better than most in the industry. Because of his experience in the industry, the talented professional designers & installation team he has assembled, and the fact that Classy Closets Utah manufactures and finishes all of their own products, they are able to provide customized solutions better than anyone else!",
      },
    ],
  },
};
